module.exports = __webpack_public_path__ + "img/duanwu_ps_14.d7f11864.jpg";